const access = {
  methods: {
    translateAccessErrorStatus(c) {
      return c === 0 // PGM | Fullarm
        ? "0 - Comando criado e publicado na fila"
        : c === 1
        ? "1 - Aguardando execução"
        : c === 2
        ? "2 - Em execução"
        : c === 3
        ? "3 - Sucesso"
        : c === 4
        ? "4 - Painel desconectou-se"
        : c === 5
        ? "5 - Tempo de espera por resposta excedido"
        : c === 6
        ? "6 - Ocorreu um erro desconhecido"
        : c === 24
        ? "24 - Falha de comunicação: Spirit não responde"
        : c === 25
        ? "25 - Falha de comunicação: Sensor não encontrado"
        : c === 26
        ? "26 - Falha de comunicação: Sensor não responde"
        : c === 27
        ? "27 - Falha de comunicação: Spirit não é monitorada"
        : c === 28
        ? "28 - Falha de comunicação: Spirit não existe"
        : c === 29
        ? "29 - PGM desabilitada"
        : c === 32
        ? "32 - Abertura de portão recusada: portão já está aberto"
        : c === 33
        ? "33 - Fechamento de portão: portão já está fechado"
        : c === 1000 // Condlink
        ? "1000 - Erro Desconhecido"
        : c === 1001
        ? "1001 - Código expirou"
        : c === 1002
        ? "1002 - Código já utilizado"
        : c === 1003
        ? "1003 - Código não pertence a este device"
        : c === 1004
        ? "1004 - Device não encontrado"
        : c === 1005
        ? "1005 - Código não encontrado"
        : c === 9900
        ? "9900 - Usuário Bloqueado pelo licenciado"
        : c === 9901
        ? "9901 - Usuário Bloqueado pela franqueadora"
        : c === 9902
        ? "9902 - Loja em Manutenção"
        : c === 9903
        ? "9903 - Proibido para Menores"
        : c === 9904
        ? "9904 - Usuário não possuí formas de pagamento suficientes"
        : c === 9905
        ? "9905 - Loja inativa"
        : c === 9906
        ? "9906 - Loja inativa (status em breve)"
        : c === 9907
        ? "9907 - Loja desativada"
        : c === 9908
        ? "9908 - Usuário não faz parte da lista de permissão de acesso desta loja"
        : c === 9921
        ? "9921 - Falha na comunicação com controle de acesso (Condlink)"
        : c === 9931
        ? "9931 - Erro ao Requisitar token API Presença"
        : c === 9932
        ? "9932 - Falha na comunicação com controle de acesso (Presença)"
        : c === 9942
        ? "9942 - Falha na comunicação com controle de acesso (Near)"
        : "Erro desconhecido";
    }
  }
};

export { access };
